import * as React from 'react';
import { ErrorText } from '@screens/review-section3/review/styles';

interface IProps {
    children: React.ReactNode;
}

export const ValidationErrorContainer = ({ children }: IProps) => {
    return <ErrorText>{children}</ErrorText>;
};



// WEBPACK FOOTER //
// ./src/screens/review-section3/review/validation-error-message.tsx